export default "__VITE_ASSET__zFHNcEU7__"